<template>
  <main id="main">
    <div class="single-content">
      
      <!-- ▼ タイトル部分 -->
      <div class="container">
        <header>
          <div class="row">
            <div class="col-12 date">{{datefilter(date)}}</div>
            <div class="col-lg-10"><h1>{{title}}</h1></div>
            <div class="col-lg-2"><a class="canClick category" @click="catMove()">{{category}}</a></div>
          </div>
        </header>
      </div>
      <!-- ▲ タイトル部分 -->
      
      <!-- ▼ 画像と説明 -->
      <div class="container narrow">
        <div class="main-visual">
          <picture>
            <img :src="host+image" :alt="title" width="2500" height="3750" class="mv">
          </picture>
        </div>
        <div class="main-text" v-html="text"></div>
      </div>
      <!-- ▲ 画像と説明 -->
      
      <!-- ▼ 注意事項 -->
      <div class="container">
        <div class="attention">
          <p>※次の事項に該当する、もしくはその恐れのある画像の使用は禁止いたします。<br>下記の使用が確認された場合、今後の掲載ができなくなることもございます。</p>
          <ul class="">
            <li>・画像の複製、転載、加工、配布(ウェブサイト、SNSを含む)</li>
            <li>・イメージを損なう使用</li>
            <li>・営利目的の使用</li>
            <li>・その他、ファンクラブの意図に反する使用</li>
          </ul>
        </div>
      </div>
      <!-- ▲ 注意事項 -->
      
      <!-- ▼ 一覧に戻る -->
      <div class="container minimum">
        <div class="back text-center">
          <div class="row">
            <div class="col-6" :style="{visibility : isFirst ? 'hidden' : 'visible'}">
              <a class="canClick btn-theme auto w-100" @click="pageMove('pre')">前へ</a>
            </div>
            <div class="col-6" :style="{visibility : isLast ? 'hidden' : 'visible'}">
              <a class="canClick btn-theme auto w-100" @click="pageMove('next')">次へ</a>
            </div>
            <div class="col-12 mt-4">
              <a class="btn-theme auto w-100 canClick" @click="toPic()">一覧に戻る</a>
            </div>
          </div>
        </div>
      </div>
      <!-- ▲ 一覧に戻る -->
      
    </div>
  </main>
</template>


<script>
  export default{
    data(){
      return{
        host: process.env.VUE_APP_IAM,
        cart: process.env.VUE_APP_CARTURI,
        cms: process.env.VUE_APP_CLIENTAPI,
        path: this.$route.path,
        num: this.$store.getters.get_pnum,
        cat: '',
        id: this.$route.params['picid'],
        pMeta:[],
        listContents:[],
        bodyContents:[],
        uInfo:[],
        fcpList:[],
        detailBody:[],
        disList:[],
        date:'',
        title:'',
        category:'',
        image:'',
        text:'',
        year:new Date().getFullYear(),
        month:new Date().getMonth()+1,
        day:new Date().getDate(),
        hour:new Date().getHours(),
        minutes:new Date().getMinutes(),
        seconds:new Date().getSeconds(),
        lastPage:Number,
        fadeapp:true,
        isFirst:true,
        isLast:true,
        rtn:'',
      }
    },
    created(){
      this.getData()
    },
    methods:{
       async getData(){
        try{
          const picList = await this.$axios.get(this.$uri+'/data_output?type=pic', { withCredentials: true })
          const picBody = await this.$axios.get(this.$uri+'/data_output?type=pic&id='+this.id, { withCredentials: true })
          this.bodyContents = picBody.data.contents
          this.pMeta = picList.data.pageMeta
          this.uInfo = this.pMeta.userInfo
          let loginAuth = this.pMeta.isAuthenticated
          this.listContents = picList.data.contents
          if(picList.data.siteMeta.isInMaintenance){
            window.location.href="/maintenance/maintenance.html"
          }else if(!loginAuth){
            this.rtn = encodeURIComponent(this.cms+'/system/login?action=login&to='+this.path)
            window.location.href = this.cart+'/v2/Login.aspx?ccode=BYU&ReturnUrl='+this.rtn
          }else{
            this.fcpList = this.listContents.filter((v)=> v.type == 'pic')
            this.detailBody = this.bodyContents[0].content
            this.date = this.detailBody.date
            this.title = this.detailBody.title
            if(this.$store.getters.get_category == 'all'){
              this.cat = 'all'
            }else{
              this.cat = this.bodyContents[0].categories[0].name
            }
            this.category = this.bodyContents[0].categories[0].displayName
            this.image = this.detailBody.image
            this.text = this.detailBody.text
            if(this.cat == 'all'){
              this.disList = this.fcpList
            }else{
              this.disList = this.fcpList.filter((v)=> v.categories[0].name == this.cat)              
            }
            this.getPageCount()
            window.scrollTo(0,0)
          }
        }catch(e){
          window.location.href="/error/504.html"
        }
      },
      pageMove(to){
        // scrollTo(0,0)
        let nextid
        if(to == 'pre'){
          for(var i=0; i<this.listContents.length; i++){
            if(this.disList[i].id == this.id){
              nextid = this.disList[i-1].id
            }
          }
        }else if(to == 'next'){
          for(var k=0; k<this.disList.length; k++){
            if(this.disList[k].id == this.id){
              nextid = this.disList[k+1].id
            }
          }
        }
        this.$gtag.query('config', 'G-7QXE3V2MV2', {'page_path': '/fanclubtop/pic/detail/'+nextid});
        this.$router.push('/fanclubtop/pic/detail/'+nextid)
      },
      getPageCount(){
        if(this.disList.length>1){
          for(var i=0; i<this.disList.length; i++){
            if(this.disList[i].id == this.id){
              if(i == 0){
                this.$nextTick(() => {
                  this.isFirst = true
                  this.isLast = false
                })
              }else if(i == this.listContents.length-1){
                this.$nextTick(() => {
                  this.isLast = true
                  this.isFirst = false
                })
              }else{
                this.$nextTick(() => {
                  this.isFirst = false
                  this.isLast = false
                })
              }
            }
          }
        }else{
          this.isFirst = true
          this.isLast = true
        }
      },
      chkNew(date){
        if(this.day.length==1){
          this.day = '0'+this.day
        }
        if(this.month.length==1){
          this.month = '0'+this.month
        }
        let now = Date.parse(this.year+'-'+this.month+'-'+this.day)
        let release = Date.parse(date)
        if(now>=release && now<release+604800000){
          return true
        }else{
          return false
        }
      },
      toPic(){
        this.$gtag.query('config', 'G-7QXE3V2MV2', {'page_path': '/fanclubtop/pic/list/'+this.num+'?cat='+this.cat});
        this.$router.push('/fanclubtop/pic/list/'+this.num+'?cat='+this.cat)
      },
      catMove(){
        this.$gtag.query('config', 'G-7QXE3V2MV2', {'page_path': '/fanclubtop/pic/list/1?cat='+this.bodyContents[0].categories[0].name});
        this.$router.push('/fanclubtop/pic/list/1?cat='+this.bodyContents[0].categories[0].name)
      },
      datefilter(date){
        if(date != void 0){
          return date.replace(/-/g,'.')
        }
      },
    },
    watch:{
      $route(){
        this.id = this.$route.params['picid']
        this.getData()
      }
    }
  }
</script>